<template>
	<div>
		<helio-separator
			v-if="block.content.type === 'line'"
			class="separator-block separator-block--line"
		/>
		<div v-if="block.content.type === 'dots'">
			<ul class="separator-block separator-block--dots">
				<li />
				<li />
				<li />
			</ul>
		</div>
	</div>
</template>
<script>
import Separator from '../../../separator/Separator.vue';

export default {
	components: {
		'helio-separator': Separator,
	},
	props: {
		block: {
			type: Object,
			required: true,
		},
		next: {
			type: Object,
			required: false,
			default: null,
		},
	},
};
</script>

<style lang="scss" src="./separator-block.scss" />
